export const UI_ENV = 'prod'; // dev, prod
